import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Rightpart.css";
import profile from "../assets/images/profile.png"; 
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from "react-bootstrap/Accordion";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { fetchUserAppAPI } from '../../utils/api';

export default function SupportRight() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  // FAQs state
  const [faqs, setFaqs] = useState([]);
  
  // Form states
  const [requestType, setRequestType] = useState("Order Issue");
  const [comment, setComment] = useState("");
  
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/login");
      return;
    }
    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);
    
    // Fetch data
    fetchFaqs();
  }, [navigate]);

  const fetchFaqs = async () => {
    try {
      const response = await fetchUserAppAPI("ticket-faq", {
        method: "GET"
      });

      if (response && response.status === 200 && Array.isArray(response.result)) {
        setFaqs(response.result);
      }
    } catch (err) {
      console.error("Error fetching FAQs:", err);
    }
  };

  const handleTicketSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;
    if (!comment.trim()) {
      setError("Please enter your comment.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await fetchUserAppAPI("support", {
        method: "POST",
        body: JSON.stringify({
          usr_id: user.user_id,
          usr_subject: requestType,
          usr_comment: comment
        }),
      });

      if (response && response.status === 200) {
        setSuccess(response.msg || "Your ticket has been submitted successfully.");
        setComment("");
      } else {
        setError(response.msg || "Failed to submit ticket.");
      }
    } catch (err) {
      setError("An error occurred while submitting your ticket.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='outer-div-right'>
       <div className='dashbord-right-section'>

         <div className='content-dashborad-outer'>
              <div className='row'>
               <div className='col-lg-12'>
                <div className='supot-form-box'>
                  <div className='box-top'>
                   <div className='sr-number'>
                      <h4>Create Ticket</h4>
                    </div>
                 </div>
                  <div className='billing-text ticket-form'>
                      {success && <div className="alert alert-success py-2">{success}</div>}
                      {error && <div className="alert alert-danger py-2">{error}</div>}

                      <form className="ticket-form" onSubmit={handleTicketSubmit}>
                      <div className="form-row">
                        <div className="form-box">
                          <span className="label">Select Request Type</span>
                          <select 
                            value={requestType} 
                            onChange={(e) => setRequestType(e.target.value)}
                            disabled={loading}
                          >
                            <option value="Order Issue">Order Issue</option>
                            <option value="Payment Issue">Payment Issue</option>
                            <option value="General Inquiry">General Inquiry</option>
                            <option value="Feedback">Feedback</option>
                          </select>
                        </div>
                        <div className="form-box">
                          <span className="label">Comment</span>
                          <textarea 
                            placeholder="Please explain your issue here..."
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            disabled={loading}
                            required
                          ></textarea>
                        </div>
                      </div>
                      <button className="ticket-submit-btn submit-btn" type="submit" disabled={loading}>
                        {loading ? "Submitting..." : "Submit Ticket"}
                      </button>
                    </form>
                  </div>
                </div>
               </div>

                <div className='col-xl-7 col-lg-12 col-12'>
                 <div className='support-hsty'>
                   <div className='box-top'>
                    <div className='sr-number'>
                        <h4>Latest Support History</h4>
                      </div>
                    </div>
                    <div className='billing-text ticket-data table-responsive'>
                      <table className="ticket-table">
                          <tbody>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>25/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status inprocess">
                                <p>Inprocess</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>12/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status approve">
                                <p>Approve</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>12/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status submit">
                                <p>Approve</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>12/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status cancel">
                                <p>Approve</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                    </div>
                 </div>
               </div>

                <div className="col-xl-5 col-lg-12 col-12">
                     <div className="billing-add-box password-sect">
                       <div className="box-top">
                         <div className="sr-number">
                           <h4>faqs</h4>
                         </div>
                       </div>
                       <div className="billing-text need_help_dash">
                           <Accordion className="custom-faq" defaultActiveKey="0">
                             {faqs.length === 0 ? (
                               <p className="text-muted small p-3 text-center">No FAQs available.</p>
                             ) : (
                               faqs.map((faq, index) => (
                                 <Accordion.Item eventKey={String(index)} key={faq.tf_id}>
                                   <Accordion.Header>
                                     {faq.tf_title}
                                   </Accordion.Header>
                                   <Accordion.Body>
                                     {faq.tf_description}
                                   </Accordion.Body>
                                 </Accordion.Item>
                               ))
                             )}
                           </Accordion>
                       </div>
                     </div>
                   </div>
              </div>
          </div>
        </div>
     </div>
  )
}



// import React from "react";
// import "./Rightpart.css";
// import profile from "../assets/images/profile.png";
// import deshboardimg from "../assets/images/deshboard-img.png";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

// export default function SupportRight() {
//   return (
//     <div className="outer-div-right">
//       <div className="dashbord-right-section">
//         <div className="dashbord-header">
//           <p className="title-dash">Support</p>
//           <div className="profile-name">
//             <img src={profile} alt="" />
//             <div className="name-mail">
//               <h4>DEEPAK SHARMA</h4>
//               <p>Deepak@gmail.com</p>
//             </div>
//           </div>
//         </div>
//         <div className="content-dashborad-outer">
          
//           <div className="table-dashbord">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Order ID</th>
//                   <th>Order Status</th>
//                   <th>Date</th>
//                   <th>Number of Product</th>
//                   <th>Amount</th>
//                   <th>View</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status placed">Placed</span>
//                   </td>
//                   <td>17-04-2026</td>
//                   <td>2</td>
//                   <td>30,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status dispatch">Dispatch</span>
//                   </td>
//                   <td>15-04-2026</td>
//                   <td>1</td>
//                   <td>10,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status packed">Packed</span>
//                   </td>
//                   <td>12-04-2026</td>
//                   <td>3</td>
//                   <td>5,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#123</td>
//                   <td>
//                     <span className="status delivered">Delivered</span>
//                   </td>
//                   <td>18-04-2026</td>
//                   <td>5</td>
//                   <td>60,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status pending">Pending</span>
//                   </td>
//                   <td>1-04-2026</td>
//                   <td>8</td>
//                   <td>70,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
